document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll("tab-gallery");

  galleries.forEach((gallery) => {
    const tabs = gallery.querySelectorAll(".tab-gallery__tab");
    const images = gallery.querySelectorAll(".tab-gallery__image");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const blockId = tab.getAttribute("data-block-id");

        // Remove active class from all tabs within this gallery
        tabs.forEach((t) => t.classList.remove("tab-gallery__tab--active"));

        // Add active class to clicked tab
        tab.classList.add("tab-gallery__tab--active");

        // Remove active class from all images within this gallery
        images.forEach((img) => img.classList.remove("tab-gallery__image--active"));

        // Add active class to the matching image
        const activeImage = gallery.querySelector(`.tab-gallery__image[data-block-id="${blockId}"]`);
        if (activeImage) {
          activeImage.classList.add("tab-gallery__image--active");
        }
      });
    });
  });
});